module.exports = __webpack_public_path__ + "static/media/change_clean_filter.8a4c8536.svg";